export const logToAzure = data => {
    if (!window.appInsights) {
        // console.info(`appInsights does not exist: ${data}`);
        return;
    }

    window.appInsights.trackMetric({
        name: data.name,
        average: Math.ceil(((data.duration) / 1000) * 100) / 100,
        properties: {
            waitTimeUnit: "Second",
            trigger: `Time until ${data.name}`,
            v3ScriptHost: window?.app?.config?.v3ScriptHost,
            item: data?.item
        }
    });
};
